import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { ReportSelectComponent } from "../../../../shared/component/report-select/report-select.component";
import { environment } from '../../../../../environments/environment'; // adjust path
import { DestroyableComponent } from '../../../../shared/services/destroyable.component';
import { ApiCallsService } from '../../../../shared/services/api-calls.service';
export type ReportType =
  | 'HEADERS'
  | 'DAILY_REPORT_CSV'
  | 'MONTHLY_REPORT_CSV'
  | 'RECHARGE_HISTORY_CSV';

export interface ReportHeader {
  name: string;
  key: string;
}

export interface ReportHeadersPayload {
  type: 'HEADERS';
}

export interface ReportFilterPayload {
  type: Exclude<ReportType, 'HEADERS'>;
  id: string;
  fromDate: string;
  toDate: string;
  header: ReportHeader[];
}
@Component({
  selector: 'app-csv-report',
  standalone: true,
  imports: [ReportSelectComponent, CommonModule],
  templateUrl: './csv-report.component.html',
  styleUrl: './csv-report.component.scss'
})
export class CSVREPORTComponent extends DestroyableComponent implements OnInit {
  private route = inject(ActivatedRoute);
  private reportApiService = inject(ApiCallsService);

  reportType: Exclude<ReportType, 'HEADERS'> =
    this.route.snapshot.data['reportType'];
  HeaderShow:string = this.route.snapshot.data['parentBreadcrumb']
  headers: ReportHeader[] = [];
  selectedHeaders: ReportHeader[] = [];

  siteId: string = 'ALL';
  fromDate: string = '';
  toDate: string = '';

  isDownloading = false;
  
  ngOnInit(): void {
    this.fetchHeaders();
  }

  private fetchHeaders(): void {
    const payload: ReportHeadersPayload = {
      type: 'HEADERS',
    };

    this.reportApiService.CSVHeaders(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe((res: any) => {
        this.headers = (res?.Data[this.reportType] ?? []).map((h: any) => ({
          name: h.name,
          key: h.key
        }));
        this.selectedHeaders = [...this.headers];
      });
  }

  isHeaderSelected(header: ReportHeader): boolean {
    return this.selectedHeaders.some(h => h.key === header.key);
  }

  toggleHeader(header: ReportHeader, checked: boolean): void {
    this.selectedHeaders = checked
      ? [...this.selectedHeaders, header]
      : this.selectedHeaders.filter(h => h.key !== header.key);
  }

filterApplied(payloadApplied:any): void {
    const payload: any = {
      type: this.reportType,
      site_id: payloadApplied.site_ids,
      fromDate: payloadApplied.from_date,
      toDate: payloadApplied.to_date,
      header: this.selectedHeaders
    };

    this.isDownloading = true;

    this.reportApiService.CSVDownload(payload)
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: (res: any) => {
          console.log('Filtered report data:', res);
          this.triggerCsvDownload(res, payload);
        },
        error: (err) => {
          console.error('CSV report API error:', err);
          console.error('Status:', err?.status, 'Message:', err?.message);
          console.error('Payload sent:', payload);
          this.isDownloading = false;
        },
        complete: () => {
          this.isDownloading = false;
        }
      });
  }

  private triggerCsvDownload(res: any, payload: ReportFilterPayload): void {
    const blob = res instanceof Blob
      ? res
      : new Blob([res], { type: 'text/csv' });

    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `${payload.type}_${payload.fromDate}_${payload.toDate}.csv`;
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }
}